import clsx from 'clsx';
import { type ExportScopeType } from '@/app/enums/ExportScopeType';

export type ExportScopeOption = {
  value: ExportScopeType;
  label: string;
  icon: string;
  description: string;
  /** Quantas linhas saem no arquivo com este escopo. */
  rows: number;
  disabled?: boolean;
};

type Props = {
  options: ExportScopeOption[];
  value: ExportScopeType;
  onChange: (scope: ExportScopeType) => void;
};

/** "Quais linhas?": lista de rádio, cada opção com descrição e contagem. */
const ExportScopeOptions = ({ options, value, onChange }: Props) => (
  <>
    <div className="form-label fw-semibold fs-7 text-gray-600" id="export-scope-title">
      Quais linhas?
    </div>
    <div aria-labelledby="export-scope-title" className="mb-5" role="radiogroup">
      {options.map((option) => {
        const active = value === option.value;
        return (
          <label
            key={option.value}
            className={clsx(
              'd-flex align-items-center gap-4 border rounded px-4 py-3 mb-2',
              option.disabled ? 'opacity-50' : 'cursor-pointer',
              active ? 'border-primary bg-light-primary' : 'border-gray-300',
            )}
          >
            <input
              checked={active}
              className="form-check-input flex-shrink-0"
              disabled={option.disabled}
              name="export-scope"
              type="radio"
              onChange={() => onChange(option.value)}
            />
            <i className={clsx('bi fs-2', option.icon, active ? 'text-primary' : 'text-gray-500')} />
            <span className="flex-grow-1">
              <span className="fw-bold text-gray-900 d-block">{option.label}</span>
              <span className="fs-7 text-gray-600">{option.description}</span>
            </span>
            <span className={clsx('badge fw-bold', active ? 'badge-primary' : 'badge-light')}>
              {option.rows.toLocaleString('pt-BR')}
            </span>
          </label>
        );
      })}
    </div>
  </>
);

export default ExportScopeOptions;
